export default "https://cdn-static.gokick.com/assets/5afcce0631de89212d84c9203934006157ee1462/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";